import mutations from './mutations'
import actions from './actions'

const state = {
  stack: [],
  websock: null,
  messages_data: {
    audio: '',
    status: 0,
  },
}

export default {
  state,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/vuex/modules/messages/messages.js